import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ProfileCompanyModel } from '@libs/core/api';

@Injectable()
export class CompanyInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  private company!: ProfileCompanyModel;

  constructor() {
    this.authService.currentCompany$.subscribe((company) => (this.company = company));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let clonedReq = request;

    if (this.company) {
      clonedReq = request.clone({
        headers: request.headers.set('Company', this.company.id),
      });
    }

    return next.handle(clonedReq);
  }
}
